import type { IRoute } from 'v2/types'
import { LegacyLoginRedirect } from './legacy-login-redirect'
import { rows } from './redirect-rows'

// Old console (console.plivo.com) URLs → CX pages. Once its ALB rule is live it forwards old browser
// URLs here unchanged (machine paths get a 410 there instead). A `/*` row also matches its bare prefix.

// Pages that must work while logged out (rendered outside ProtectedRoute). Static segments outrank
// `/*`, so protected pages such as /accounts/ip-whitelist and /sso/configure still win.
export const legacyConsoleOpenRoutes: IRoute[] = [
  {
    title: '',
    path: '/accounts/login',
    component: <LegacyLoginRedirect />,
    hidden: true,
  },
  ...rows([
    [['/accounts/password/reset', '/accounts/password/reset/confirm/*'], '/forgot-password'],
    [
      [
        '/accounts/create-account',
        '/accounts/register',
        '/accounts/registration/*',
        '/accounts/request-trial',
      ],
      '/signup',
    ],
    ['/accounts/resendactivation', '/resend-activation-email'],
    [
      [
        '/accounts/*',
        '/account/users/activate/:activation_token',
        '/login/verify_otp',
        '/login/resend_otp',
        '/login/change-number',
        '/login/authenticator-app',
        '/login/recovery-code',
        '/sso/*',
        '/auth',
        '/redirect/*',
      ],
      '/login',
    ],
  ]),
]

// Everything else is behind login. No CX page → /home; PHLO → /agents. Pages with an ID carry it over.
export const legacyConsoleRoutes: IRoute[] = rows([
  [
    [
      '/dashboard/*',
      '/demos',
      '/voice/overview',
      '/sms/overview',
      '/voice/dashboard',
      '/sms/dashboard',
      '/accounts/questionnaire',
      '/verification/*',
      '/switch_account/*',
      '/default_account',
      '/get_prerequisites',
      '/fetchcityzipcodes',
      '/get_user_metrics',
      '/feedback',
      '/contact/*',
      '/fapi',
      '/send-blocked-risk-mail',
      '/check-login-anomalies',
      '/api/*',
      '/v1/*',
      '/numbers/*',
      '/phone-numbers/byoc/*',
      '/carrier/*',
      '/voice/settings/callinsights',
      '/voice/callinsights',
      '/voice/advanced_insights',
      '/sms/mms-media-upload',
      '/sms/powerpacks/*',
      '/powerpack/*',
      '/lookup/*',
      '/voice/*',
      '/sms/*',
    ],
    '/home',
  ],
  [
    [
      '/dashboard/setup2fa',
      '/dashboard/setup2fa/email-verify',
      '/dashboard/setup_2fa/*',
      '/dashboard/phone-activation',
      '/dashboard/phone-verification',
      '/verify/two_fa_otp',
      '/resend/two_fa_otp',
    ],
    '/profile/2fa',
  ],
  [
    [
      '/account/profile',
      '/user/profile',
      '/user/*',
      '/account/verify-user',
      '/account/*',
      '/account/password/change',
      '/accounts/password/change/done',
    ],
    '/profile/details',
  ],
  ['/account/users/*', '/organization-settings/users'],
  ['/accounts/ip-whitelist/*', '/organization-settings/ip-whitelisting'],
  [
    ['/account/auth-token/generate', '/dashboard/delete-old-auth-token'],
    '/organization-settings/api-keys',
  ],
  [['/subaccounts/*', '/subaccount/*'], '/organization-settings/sub-accounts'],
  [['/accounts/recharge-limits', '/payments/payment_limit'], '/organization-settings/limits'],
  [
    ['/accounts/manage', '/account/delete/*', '/close_account/*', '/account/upgrade/*'],
    '/organization-settings/general',
  ],
  [
    ['/sso/configure', '/sso/generate_portal_link', '/sso/workos_organization'],
    '/organization-settings/sso',
  ],
  [
    ['/payments/*', '/autorechargeoptions', '/update_email_alerts', '/accounts/coupon'],
    '/billing/overview',
  ],
  [['/payments/history', '/payments/invoice/*'], '/billing/invoice-and-receipt/invoices'],
  ['/payments/profile', '/billing/information'],
  [
    [
      '/payments/settings',
      '/payments/ach/*',
      '/payments/ach-schedule',
      '/payments/bank-transfer',
      '/payments/card/*',
    ],
    '/billing/payment-methods',
  ],
  ['/payments/usage', '/analytics/usage'],
  [
    ['/pricing/*', '/sms/pricing/*', '/voice/pricing/*', '/zentrunk/pricing/*'],
    '/billing/plans-and-pricing',
  ],
  [
    [
      '/phone-numbers/search',
      '/number/*',
      '/active-phone-numbers/*',
      '/phone-numbers/filter',
      '/phone-numbers/settings',
    ],
    '/phone-numbers/list',
  ],
  ['/unrented-phone-numbers', '/phone-numbers/unrented'],
  [
    [
      '/pending-phone-numbers/*',
      '/phone-numbers/verification/*',
      '/phone-numbers/compliance-application/*',
      '/compliance-application/*',
      '/phone-numbers/create-document',
      '/phone-numbers/get_documents',
      '/Account/Verification/*',
      '/Documents/*',
      '/Document/*',
    ],
    '/phone-numbers/compliance',
  ],
  ['/sandbox-numbers/*', '/phone-numbers/sandbox-numbers'],
  [['/phone-numbers/senderids', '/sms/sender_id/*'], '/phone-numbers/sender-id'],
  ['/voice/verified-callerid/*', '/phone-numbers/caller-id'],
  ['/phone-numbers/logs', '/phone-numbers/rental-summary'],
  [
    [
      '/port-in',
      '/port-in/success',
      '/port-in/number-check',
      '/port-in/update-order',
      '/port-in/update-order-check',
      '/port-in/loa-document',
      '/port-in/document/*',
    ],
    '/phone-numbers/port-in',
  ],
  ['/port-in/order/create', '/port-in/new'],
  ['/sms/10dlc/*', '/compliance/drafts'],
  [
    [
      '/sms/10dlc/brands',
      '/sms/10dlc/brand',
      '/sms/10dlc/brand/register',
      '/sms/10dlc/campaigns',
      '/sms/10dlc/campaign',
      '/sms/10dlc/campaign/register',
    ],
    '/compliance/10dlc',
  ],
  [
    [
      '/sms/10dlc/tollfree_verification',
      '/sms/10dlc/tollfree_verification/create',
      '/sms/10dlc/tollfree_verification/update',
    ],
    '/compliance/toll-free',
  ],
  [
    [
      '/voice/logs/calls',
      '/voice/logs/*',
      '/logs/calls/*',
      '/logs/debug/*',
      '/logs/concurrency/*',
      '/logs/fair-usage/*',
    ],
    '/logs/voice',
  ],
  [
    [
      '/voice/logs/recordings',
      '/logs/recordings/filter',
      '/logs/recordings/export',
      '/logs/recordings/remove',
      '/logs/recordings/bulk_delete',
    ],
    '/logs/recordings',
  ],
  [
    ['/voice/logs/transcriptions', '/logs/transcriptions/filter', '/logs/transcriptions/export'],
    '/logs/transcriptions',
  ],
  [
    [
      '/sms/logs/messages',
      '/sms/logs/messages/latest',
      '/sms/logs/messages/data/*',
      '/sms/logs/*',
      '/logs/messages/export',
    ],
    '/logs/messages',
  ],
  [
    ['/whatsapp/logs/messages', '/whatsapp/logs/messages/data', '/whatsapp/logs/*'],
    '/logs/whatsapp',
  ],
  [['/verify/logs/export', '/verify/logs/*'], '/logs/verify'],
  [
    ['/zentrunk/logs/calls', '/zentrunk/logs/*', '/trunk/logs/*', '/zentrunk/pcap_download'],
    '/logs/sip-trunking',
  ],
  [
    ['/voice/applications/*', '/sms/applications/*', '/app/*', '/voice/app/*', '/sms/app/*'],
    '/applications',
  ],
  [['/voice/endpoints/*', '/endpoint/*'], '/endpoints'],
  ['/voice/settings/alerts/*', '/alerting/voice'],
  ['/sms/settings/delivery-alerts', '/alerting/messages'],
  ['/voice/settings/geo-permissions/*', '/geo-permissions/voice'],
  ['/sms/settings/geo-permissions/*', '/geo-permissions/messaging'],
  [['/zentrunk/geo-permissions', '/zentrunk/geo-permission/*'], '/geo-permissions/sip-trunking'],
  [['/voice/settings/*', '/push-credentials/*'], '/organization-settings/voice'],
  [['/sms/settings/*', '/sms/fraud-shield/*'], '/organization-settings/messaging'],
  ['/sms/reporting', '/analytics/usage/messaging'],
  [['/verify/overview', '/verify/applications/*'], '/verify'],
  ['/whatsapp/whatsapp_business_account/*', '/whatsapp/numbers'],
  ['/whatsapp/whatsapp_business_account/:waba_id/templates', '/whatsapp/templates'],
  ['/whatsapp/whatsapp_business_account/:waba_id/configurations', '/whatsapp/configurations'],
  [
    [
      '/zentrunk/trunks',
      '/zentrunk/ip-groups',
      '/zentrunk/auth-groups',
      '/zentrunk/api/ip-groups',
      '/zentrunk/api/auth-groups',
      '/trunk/*',
    ],
    '/sip-trunking/outbound',
  ],
  [
    [
      // /trunk (old dashboard) is inbound; /trunk/* (outbound trunk pages) is outbound above.
      '/zentrunk/dashboard',
      '/zentrunk/*',
      '/trunk',
      '/zentrunk/inbound-trunks',
      '/zentrunk/inbound/*',
      '/zentrunk/trunk-uri/*',
      '/zentrunk/api/inbound-trunks',
      '/zentrunk/api/trunk-uri',
    ],
    '/sip-trunking/inbound',
  ],
  [['/phlo/*', '/proxy/*'], '/agents'],
  [
    ['/sms/logs/messages/:message_uuid', '/sms/logs/debug/call/:message_uuid'],
    (p) => `/logs/messages/${p.message_uuid}`,
  ],
  [
    ['/whatsapp/logs/messages/:message_uuid', '/whatsapp/logs/debug/call/:message_uuid'],
    (p) => `/logs/whatsapp/${p.message_uuid}`,
  ],
  [
    [
      '/voice/logs/calls/stats/:call_uuid',
      '/voice/logs/debug/call/:call_uuid',
      '/logs/debug/call/:call_uuid',
    ],
    (p) => `/logs/voice/${p.call_uuid}`,
  ],
  ['/verify/logs/:session_uuid', (p) => `/logs/verify/${p.session_uuid}`],
  ['/zentrunk/logs/call/debug/:call_uuid', (p) => `/logs/sip-trunking/${p.call_uuid}`],
  [
    ['/port-in/order/:requestId', '/port-in/configure/:requestId'],
    (p) => `/port-in/${p.requestId}`,
  ],
  [
    [
      '/sms/10dlc/brand/:id',
      '/sms/10dlc/brand/:id/update',
      '/sms/10dlc/brand/:id/register',
      '/sms/10dlc/brand/:id/campaign',
      '/sms/10dlc/brand/:id/vet',
      '/sms/10dlc/brand/:id/otp',
    ],
    (p) => `/compliance/brand/${p.id}`,
  ],
  [
    [
      '/sms/10dlc/campaign/:id',
      '/sms/10dlc/campaign/:id/update',
      '/sms/10dlc/campaign/:id/numbers',
      '/sms/10dlc/brand/:brandId/campaign/:id',
      '/sms/10dlc/brand/:brandId/campaign/:id/number/link',
    ],
    (p) => `/compliance/campaign/${p.id}`,
  ],
  ['/sms/10dlc/tollfree_verification/:id', (p) => `/compliance/tollfree/${p.id}`],
  // Behind login like the old page was; the CX receipt view needs the profile cache warm.
  ['/payments/receipt/:uuid', (p) => `/billing/receipt/${p.uuid}`],
])
